import React, { useState } from 'react'
import useStyles from './style'
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Divider,
  Button,
} from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import ContactUsModal from './contactUsModal'
import CustomRequestModal from './customRequestModal'
import { useSelector } from 'react-redux'

const Contact = () => {
  const classes = useStyles()
  const contactDetails = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.contactDetails
  )
  const stores = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.stores
  )
  const [openContactModal, setOpenContactModal] = useState(false)
  const [openRequestModal, setOpenRequestModal] = useState(false)

  // Handle contact us modal
  const handleOpenContactModal = () => {
    setOpenContactModal(true)
  }
  const handleCloseContactModal = () => {
    setOpenContactModal(false)
  }

  // Handle custom request modal
  const handleOpenRequestModal = () => {
    setOpenRequestModal(true)
  }
  const handleCloseRequestModal = () => {
    setOpenRequestModal(false)
  }

  return (
    <>
      <Grid container className={classes.root}>
        {/* Breadcrumbs */}
        <Grid item xs={12} className={classes.breadcrumbs}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Typography variant="body1">Contact us</Typography>
          </Breadcrumbs>
        </Grid>
        {/* Header Label */}
        <Grid item xs={12} className={classes.headerLabel}>
          <Typography variant="h2">How can we help?</Typography>
          <Divider />
        </Grid>
        {/* Buttons */}
        <Grid item xs={12} className={classes.btnWrapper}>
          <Grid item xs={12} sm={6}>
            <section className={classes.btnContainer}>
              <div>
                <Typography variant="h4">Get in touch with us</Typography>
              </div>
              <div>
                <Button
                  variant="contained"
                  disableElevation
                  color="secondary"
                  onClick={handleOpenContactModal}
                >
                  Contact us
                </Button>
              </div>
            </section>
          </Grid>
          <Grid item xs={12} sm={6}>
            <section className={classes.btnContainer}>
              <div>
                <Typography variant="h4">
                  Need a custom product requirement
                </Typography>
              </div>
              <div>
                <Button
                  variant="contained"
                  disableElevation
                  color="secondary"
                  onClick={handleOpenRequestModal}
                >
                  Custom Request
                </Button>
              </div>
            </section>
          </Grid>
        </Grid>
        {/* Address */}
        {/* <Grid item xs={12} className={classes.addressWrapper}>
          <Grid item xs={12} sm={6} className={classes.addressTextWrapper}>
            <section className={classes.addressText}>
              <Typography variant="h6">
                {contactDetails?.address || ''}
              </Typography>
            </section>
          </Grid>
          <Grid item xs={12} sm={6}>
            <section
              className={classes.imgContainer}
              onClick={() =>
                window.open(
                  'https://www.google.com/maps/place/Avathar+Jewellers/@11.0172594,76.9643884,16.74z/data=!4m14!1m7!3m6!1s0x3ba858ff71fc307d:0x81c13361ca78cb00!2sAvathar+Jewellers!8m2!3d11.0172595!4d76.9633792!16s%2Fg%2F124ykkvxb!3m5!1s0x3ba858ff71fc307d:0x81c13361ca78cb00!8m2!3d11.0172595!4d76.9633792!16s%2Fg%2F124ykkvxb',
                  '_blank'
                )
              }
            >
              <img
                src="/assets/images/map1.jpg"
                alt="locationMap"
                className={classes.img}
              />
            </section>
          </Grid>
        </Grid> */}
        <Grid item xs={12} className={classes.addressWrapper}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className={classes.addressCardWrapper}
          >
            <section
              className={classes.addressCard}
              onClick={() =>
                window.open(contactDetails?.homeBranchMapLink, '_blank')
              }
            >
              <div className={classes.addressText}>
                <Typography variant="h6">
                  {contactDetails?.homeBranchCity}
                </Typography>
              </div>
              <div className={classes.address}>
                <Typography variant="h6">
                  {contactDetails?.homeBranchAddress}
                </Typography>
              </div>
              <div className={classes.address}>
                <Typography variant="h6">
                  <strong>contact</strong> -{' '}
                  {contactDetails?.homeBranchMobileNo},{' '}
                  {contactDetails?.homeBranchLandlineNo}
                </Typography>
              </div>
            </section>
          </Grid>
          {stores?.map((data) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className={classes.addressCardWrapper}
              key={data?._id}
            >
              <section
                className={classes.addressCard}
                onClick={() => window.open(data?.mapLink, '_blank')}
              >
                <div className={classes.addressText}>
                  <Typography variant="h6">{data?.city}</Typography>
                </div>
                <div className={classes.address}>
                  <Typography variant="h6">{data?.address}</Typography>
                </div>
                <div className={classes.address}>
                  <Typography variant="h6">
                    <strong>contact</strong> - {data?.mobileNo},{' '}
                    {data?.landlineNo}
                  </Typography>
                </div>
              </section>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <ContactUsModal
        open={openContactModal}
        handleClose={handleCloseContactModal}
        title="Contact us"
        btnLabel="Submit"
      />
      <CustomRequestModal
        open={openRequestModal}
        handleClose={handleCloseRequestModal}
        title="Custom Request"
        btnLabel="Submit"
      />
    </>
  )
}

export default Contact
